import { useGetMerchantQuery } from 'services/merchants';

import useGetUuid from 'components/accountSettings/utils';

import PayoutReserve from './payoutReserve';

const PayoutReserveContainer = () => {
  const merchantUuid = useGetUuid() ?? '';

  const { data: merchant } = useGetMerchantQuery(merchantUuid!, {
    skip: !merchantUuid,
  });

  return <PayoutReserve cryptoPayoutBalances={merchant?.data.cryptoPayoutBalances} />;
};

export default PayoutReserveContainer;
